/**
 * 学员列表
 * @author wql
 * @date 2020-8-23
 */
import React from 'react';
import { connect } from 'dva';

import { framework_tool, component_tool, utils_tool } from '@/tool';
import { modelUtils } from '@/utils';
import {WizModalUserIdentityShow} from '../../../../containers/common';
import createColumns from "./columns";
import {Descriptions} from "antd";
import TrainPathInfo from './components/trainPathInfo';

const { WizContainer } = framework_tool
const { WizRow, WizCol,WizTable,WizCard,WizSpin,WizCollapse,WizModal,WizTypography,WizTag,WizSearchBar,WizDataTable} = component_tool;
const { Session,getPageData } = utils_tool;


const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/trainPath/studentTrainPathList') {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('studentTrainPathList', record)
      } else {
        record = Session.get('studentTrainPathList') || 0
      }
    }
  } else {
    record = Session.get('studentTrainPathList') || 0
  }
  return record
}

class studentTrainPathList extends WizContainer {

  componentName = 'studentTrainPathList';

  constructor(props) {
    super(props);
    this.state = {
      getPathInfo: [],
      getStudentPathList:[],
      getStudentInfo:[],
      visible:false,
      modelName:'',
      apiParams:{},
      showUserPersonInfoVisible: false,
      personId: '',
    }
    this.initialValue = getParamRecord(props.history);
  }

  propsAndStateOnChange = {
    getPathInfo:this._handleCMD.bind(this),
    getStudentPathList: this._studentPathList.bind(this),
    getStudentPathInfo: this._getStudentPathInfo.bind(this)
  };

  _handleCMD(nextProps, nextState) {
    let o = nextProps.getPathInfo;
    if (o['success']) {
      nextState.getPathInfo = o.data
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _studentPathList(nextProps, nextState) {
    let o = nextProps.getStudentPathList;
    if (o['success']) {
      let data = o.data.records;
      nextState.getStudentPathList = o.data.records
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _getStudentPathInfo(nextProps, nextState) {
    let o = nextProps.getStudentPathInfo;
    if (o['success']) {
      let data = o.data;
      // data.forEach(val =>{
      //   if (val.accountState == 0){
      //     val.accountState = '有效'
      //   }else if (val.accountState == 0){
      //     val.accountState = '无效'
      //   }
      //
      //   val.stageComplete = '(' + val.stageComplete * 100 + '%)' + val.stageName
      // })
      nextState.getStudentInfo = o.data
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _componentDidMount() {
    this._getStageListDate()
    this._getDate()
  }

  _getDate(){
    this.doActions([
      {
        path: 'trainPathStage/getStudentPathList',
        payload: {
          key: 'getStudentPathList',
          apiParams: {
            id: this.initialValue.id,
            trainPathStageId:this.initialValue.trainPathStageId
          }
        }
      },
    ]);
  }

  _getStageListDate(){
    this.doActions([
      {
        path: 'trainPathStage/getPathInfo',
        payload: {
          key: 'getPathInfo',
          apiParams: {id: this.initialValue.id}
        }
      },
    ]);
  }

  getPathList(){
    let columns = [
      { title: '任务名称',
        dataIndex: 'name',
        key: 'name'},
      { title: '任务类型',
        dataIndex: 'type',
        key: 'type'},
      { title: '任务内容',
        dataIndex: 'entityName',
        key: 'entityName'},
      { title: '任务学习方式',
        dataIndex: 'learningStyle',
        key: 'learningStyle'},
      { title: '任务状态',
        dataIndex: 'state',
        key: 'state'},
      { title: '添加时间',
        dataIndex: 'createTime',
        key: 'createTime'},
    ]
    let pathList = this.state.getPathInfo;
    let data = [];
    if (pathList.length>0){
      pathList.forEach(info =>{
        if(info.state = 1){
          info.state = '草稿'
        }else if(info.state = 2){
          info.state = '已发布'
        }else if(info.state = 3){
          info.state = '已关闭'
        }else if(info.state = 4){
          info.state = '建设中'
        }
        let header = info.name + '  ' + '[ '+ info.state + ' ]' + '(已参加人数：' + info.joinNum + ',已经通过人数：'
          + info.passNum + ',未通过人数：' + info.failNum + ')'

        info.taskList.forEach(val =>{
          if (val.type == 1){
            val.type = '在线课程'
          }else if(val.type == 2){
            val.type = '在线考试'
          }else if(val.type == 3){
            val.type = '培训班级'
          }else if(val.type == 4){
            val.type = '能力认证'
          }else if(val.type == 5){
            val.type = '在线评语'
          }else if (val.type == 6) {
            val.type = '课程组'
          }else if(val.type == 7) {
            val.type = '资讯'
          }else if(val.type == 8) {
            val.type = '作业'
          }

          if (val.learningStyle == 0){
            val.learningStyle = '自主学习'
          }else if(val.learningStyle == 1){
            val.learningStyle = '顺序学习'
          }

          if(val.state == 1){
            val.state = '草稿'
          }else if(val.state == 2){
            val.state = '已发布'
          }else if(val.state == 3){
            val.state = '已关闭'
          }
        })
        data.push(
          <WizCollapse className='administrationScope-collapse'
                       expandIconPosition='right'
                       defaultActiveKey={[
                         0
                       ]}
          >
            <WizCollapse.Panel key={info.id} header={header} className='panel-item'>
              <WizTable dataSource={info.taskList} columns={columns} />;
            </WizCollapse.Panel>
          </WizCollapse>
        )
      })
      return data
    }else{

      return (<div> </div>);
    }
  };



  getStudentPathInfo(){
    let columns = [
      { title: '任务名称',
        dataIndex: 'name',
        key: 'name'},
      { title: '任务类型',
        dataIndex: 'type',
        key: 'type'},
      { title: '任务内容',
        dataIndex: 'entityName',
        key: 'entityName'},
      { title: '状态',
        dataIndex: 'taskPassState',
        key: 'taskPassState'},
      { title: '完成时间',
        dataIndex: 'taskPassTime',
        key: 'taskPassTime'},
    ]
    let pathList = this.state.getStudentInfo;
    let data = [];
    if (pathList.length>0){
      pathList.forEach(info =>{
        if(info.state = 1){
          info.state = '草稿'
        }else if(info.state = 2){
          info.state = '已发布'
        }else if(info.state = 3){
          info.state = '已关闭'
        }else if(info.state = 4){
          info.state = '建设中'
        }

        info.taskList.forEach(val =>{
          if (val.type == 1){
            val.type = '在线课程'
          }else if(val.type == 2){
            val.type = '在线考试'
          }else if(val.type == 3){
            val.type = '培训班级'
          }else if(val.type == 4){
            val.type = '能力认证'
          }else if(val.type == 5){
            val.type = '在线评语'
          }else if (val.type == 6) {
            val.type = '课程组'
          }else if(val.type == 7) {
            val.type = '资讯'
          }else if(val.type == 8) {
            val.type = '作业'
          }

          if (val.taskPassState == 1){
            val.taskPassState = '通过';
          }else if (val.taskPassState == 0){
            val.taskPassState = '未通过';
          }
          if(val.type == '作业' && val.taskPassState == '未通过'){
            val.taskPassTime=""
          }

        })

        let header = info.name + '(' + info.proportion + ')'
        data.push(
          <WizCollapse className='administrationScope-collapse'
                       expandIconPosition='right'
                       defaultActiveKey={[
                         0
                       ]}
          >
            <WizCollapse.Panel key={info.id} header={header} className='panel-item'>
              <WizTable dataSource={info.taskList} columns={columns} />;
            </WizCollapse.Panel>
          </WizCollapse>
        )
      })
      return data
    }else{

      return (<div> </div>);
    }
  };


  openModel(val){
    this.doActions([
      {
        path: 'trainPathStage/getStudentPathInfo',
        payload: {
          key: 'getStudentPathInfo',
          apiParams: {
            id: this.initialValue.id,
            personId:val.personId
          }
        }
      },
    ]);
    this.setState({
      modelName: this.initialValue.name + '-' + val.name,
      visible: true,
    });
  }


  _onSubmit(val){
    let account = val.account != undefined &&  val.account != null ? val.account : '';
    let name = val.name != undefined &&  val.name != null ? val.name : '';

    let param = {id:this.initialValue.id,trainPathStageId:this.initialValue.trainPathStageId};
    if (account != ''){
      param.account = account;
    }
    if (name != ''){
      param.name = name;
    }

    this.doActions([
      {
        path: 'trainPathStage/getStudentPathList',
        payload: {
          key: 'getStudentPathList',
          apiParams: param
        }
      },
    ]);
  }

  getStudentPathList(other = {}){
    let parame = this.state.apiParams
    parame.id = this.initialValue.id
    parame.trainPathStageId = this.initialValue.trainPathStageId
    this.doActions([
      {
        path: 'trainPathStage/getStudentPathList',
        payload: {
          key: 'getStudentPathList',
          apiParams: { ...parame, ...other }
        }
      },
    ]);
  }

  _onReset() {
    this.refs.form && this.refs.form.resetFields && this.refs.form.resetFields()
  }

  openModel(val){
    this.doActions([
      {
        path: 'trainPathStage/getStudentPathInfo',
        payload: {
          key: 'getStudentPathInfo',
          apiParams: {
            id: this.initialValue.id,
            personId:val.personId
          }
        }
      },
    ]);
    this.setState({
      modelName: this.initialValue.name + '-' + val.name,
      visible: true,
    });
  }


  imgStyle() {
    return {
      width: 250,
      height: 150,
      backgroundImage: 'url(' + this.initialValue.fileUri + ')',
      backgroundPosition: 'center 0',
      backgroundSize: '100% 100%',
      backgroundRepeat: 'no-repeat',
    }
  }


  _onManagement(record){
    this._showUserPersonModal(record.personId);
  }

  _showUserPersonModal = (personId) => {
    this.setState({
      personId : personId,
      showUserPersonInfoVisible: true,
    })
  };

  _render() {
    let imgBackStyle = this.imgStyle();
    const { getStudentPathList ,trainPathStageLoading } = this.props;
    let dataItems = getPageData(getStudentPathList.data);
    let other = {};
    let columns = createColumns(this, dataItems, other);
    let searchBarProps = {
      columns,
      onSearch: values =>
        this.setState({ apiParams: values }, () => {
          this.getStudentPathList();
        })
    };
    let dataTableProps = {
      columns,
      rowKey: "personId",
      dataItems,
      showNum: false,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        this.getStudentPathList({ current: pageNum, size: pageSize });
      },
    };

    let showUserPersonInfoVisible = this.state.showUserPersonInfoVisible;
    let personId = this.state.personId;
    let lookUserPersonInfoModal = {
      title: '查看已选任职',
      visible: showUserPersonInfoVisible,
      personId: personId,
      onCancel: (e) => {
        this.setState({
          showUserPersonInfoVisible: false,
          personId: '',
        });
      },
    };

    return (
      <>
        <WizSpin tip={'加载中'} spinning={trainPathStageLoading}>
          {/* <WizCard title={'培训路径信息'}>
            <WizRow  key={'trainPath-info'}>
              <WizCol span={6}>
                <div style={imgBackStyle}>
                  <WizTag style={{float: 'right'}}
                          color="#108ee9">{!this.initialValue || !this.initialValue.state || this.initialValue.state === 1 ? '草稿' : this.initialValue.state === 2 ? '已发布' : '已关闭'}</WizTag>
                </div>
              </WizCol>
              <WizCol span={16}>
                <Descriptions key={'trainPath-descriptions'} column={1} title={this.initialValue.name}>
                  <Descriptions.Item label="必修范围">{this.initialValue.requiredTargetScopeName}</Descriptions.Item>
                  <Descriptions.Item label="选修范围">{this.initialValue.electiveTargetScopeName}</Descriptions.Item>
                  <Descriptions.Item label="介绍">{this.initialValue.briefIntroduction}</Descriptions.Item>
                </Descriptions>
              </WizCol>
            </WizRow>
          </WizCard> */}

          <TrainPathInfo { ...this.initialValue } />


          <WizCard>
            <div className='chapter-page'>
              <div className='chapter-info'>
                <div className='chapter-info-title'>
                  <WizTypography.Text className='title'>
                    <WizRow>
                      <WizCol span={20}>{this.initialValue.stageName}</WizCol>
                    </WizRow>
                  </WizTypography.Text>
                </div>

                <div className='chapter-info-body'>
                  <div className="form-control">
                    <WizSearchBar
                      className='searchbar-interval'
                      type="grid"
                      {...searchBarProps}
                    />
                    <WizDataTable {...dataTableProps} />
                    <div className="pagination">
                      <WizDataTable.Pagination {...dataTableProps} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </WizCard>
        </WizSpin>
        <WizModalUserIdentityShow {...lookUserPersonInfoModal}/>
    <WizModal key={2} title={this.state.modelName} visible={this.state.visible} onOk={this.handleOk.bind(this)} onCancel={this.handleCancel.bind(this)} width={800}>
      <WizCollapse className='administrationScope-collapse' expandIconPosition='right' defaultActiveKey={[0]}>
        {this.getStudentPathInfo()}
      </WizCollapse>
    </WizModal>

    </>
    );
  }


  handleOk = e => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };

}




const mapStateToProps = (state, ownProps) => {
  const {trainPathStage} = state;
  const getPathInfo = modelUtils.getModelEntity(trainPathStage, "getPathInfo");
  const getStudentPathList = modelUtils.getModelEntity(trainPathStage, "getStudentPathList");
  const getStudentPathInfo = modelUtils.getModelEntity(trainPathStage, "getStudentPathInfo");
  const load = modelUtils.getLoadingState(state, ['trainPathStage','trainPath']);

  return {
    getPathInfo,
    getStudentPathList,
    getStudentPathInfo,
    ...load
  };
};

export default connect(mapStateToProps)(studentTrainPathList);
